import React from 'react';
import styled from 'styled-components';
import { Bar, Title } from '../details/styledComponents';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/material/styles';

import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

interface Props {
    sx?: SxProps;
}

const RenderErrorState: React.FC<Props> = props => {
    return (
        <Stack px={1} sx={props.sx}>
            <TitleError>Overall Score</TitleError>
            <ErrorBar>
                <ErrorText
                    paddingLeft="10px"
                    width="210px"
                    borderRadius="4px 0 0 4px"
                >
                    Error Loading Data
                </ErrorText>
                <ErrorExclam width="20px" borderRadius="0 4px 4px 0">
                    <PriorityHighIcon sx={{ fontSize: 13 }} />
                </ErrorExclam>
            </ErrorBar>
        </Stack>
    );
};

const TitleError = styled(Title)`
    color: #646468;
    width: 236px;
`;

const ErrorBar = styled(Bar)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
`;

const ErrorText = styled(Typography)`
    display: flex;
    flex-grow: 1;
    align-items: center;
    color: white;
    font-size: 12px;
    position: relative;
    font-weight: bold;
    height: 20px;
    background-color: #646468;
`;

const ErrorExclam = styled(ErrorText)`
    justify-content: center;
`;

export default RenderErrorState;
